import React, { useState } from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/landing/HeroSection';
import EmergencyCoordination from '../components/landing/EmergencyCoordination';
import AIDoctorApp from '../components/landing/AIDoctorApp';
import EcosystemMindMap from '../components/landing/EcosystemMindMap';
import MetricsSection from '../components/landing/MetricsSection';
import TrustSection from '../components/landing/TrustSection';
import FooterCTA from '../components/landing/FooterCTA';
import Footer from '../components/landing/Footer';
import Header from '../components/landing/Header';
import WhatsAppButton from '../components/WhatsAppButton';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white overflow-hidden">
      <Header />
      <main>
        <HeroSection />
        <section id="emergency">
          <EmergencyCoordination />
        </section>
        <section id="ai-doctor">
          <AIDoctorApp />
        </section>
        <EcosystemMindMap />
        <MetricsSection />
        <TrustSection />
        <section id="contact">
          <FooterCTA />
        </section>
        <Footer />
      </main>
      <WhatsAppButton />
    </div>
  );
};

export default LandingPage;
